<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="商品">
      <goods-select v-model="form.data.goodsId"/>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
      <a-button type="primary" v-if="!sellPlanGoodsId" @click="onAdd">创建</a-button>
      <a-button type="primary" v-if="sellPlanGoodsId" @click="onUpdate">更新</a-button>
      <a-button @click="onCancel">{{ $t('CANCEL') || '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _querySellPlanGoods,
  _addSellPlanGoods,
  _updateSellPlanGoods,
} from '@/api/sellPlanGoodsApi';
import GoodsSelect from '@/components/contentSelector/GoodsSelect.vue';

async function getSellPlanGoods() {
  const result = await _querySellPlanGoods(this.sellPlanGoodsId);
  if (result) {
    this.form.data.goodsId = result.goodsId;
  }
}

async function onAdd() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _addSellPlanGoods({
        sellPlanId: this.sellPlanId,
        goodsId: this.form.data.goodsId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('添加成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateSellPlanGoods(this.sellPlanGoodsId, {
        sellPlanId: this.sellPlanId,
        goodsId: this.form.data.goodsId,
      });
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功');
          this.onSubmitHandler();
        }
      }
    }
  });
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'SellPlanGoodsEdit',
  components: { GoodsSelect },
  props: {
    sellPlanId: String,
    sellPlanGoodsId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    sellPlanGoodsId() {
      if (this.sellPlanGoodsId) {
        this.getSellPlanGoods();
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getSellPlanGoods,
  },
  data() {
    return {
      form: {
        data: {
          sellPlanId: '',
          sellPlanGoodsId: '',
          goodsId: '',
        },
        rules: {
          goodsId: [{ required: true, trigger: 'blur' }],
        },
        title: '',
      },
    };
  },
  created() {
    if (this.sellPlanGoodsId) {
      this.getSellPlanGoods();
    }
  },
};
</script>
